import { InputLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export const StyledLabel = withStyles(({ palette }) => ({
  root: {
    fontSize: '20px',
    fontWeight: 500,
    color: palette.text.primary,
    '&$focused': {
      color: palette.text.primary,
    },
    '&$error': {
      color: palette.text.primary,
    },
  },
  focused: {},
  error: {},
  // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
}))(InputLabel);
